import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminChatbot() {
  const [form, setForm] = useState(null);

  useEffect(() => {
    api.get("/settings").then(r => setForm(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/settings", form);
      toast.success("Saved");
    } catch { toast.error("Save failed"); }
  };

  if (!form) return <div>Loading…</div>;
  return (
    <div data-testid="admin-chatbot">
      <h1 className="font-display text-3xl text-[color:var(--color-primary)] mb-2">Chatbot Configuration</h1>
      <p className="text-sm text-gray-500 mb-8">Customise Kama's welcome message and quick replies. The chatbot already pulls live product inventory automatically.</p>
      <form onSubmit={save} className="bg-white border border-[color:var(--color-border)] rounded p-6 space-y-4 max-w-2xl">
        <div>
          <label className="text-xs uppercase tracking-widest text-gray-600">Welcome Message</label>
          <textarea rows="3" value={form.chatbot_welcome} onChange={(e) => setForm({ ...form, chatbot_welcome: e.target.value })} className="w-full mt-1 border border-[color:var(--color-border)] rounded px-3 py-2" data-testid="chatbot-welcome-input"/>
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-gray-600">Quick Replies (one per line)</label>
          <textarea rows="4" value={(form.chatbot_quick_replies || []).join("\n")} onChange={(e) => setForm({ ...form, chatbot_quick_replies: e.target.value.split("\n").filter(Boolean) })} className="w-full mt-1 border border-[color:var(--color-border)] rounded px-3 py-2" data-testid="chatbot-quick-input"/>
        </div>
        <button type="submit" className="btn-primary" data-testid="chatbot-save">Save</button>
      </form>
    </div>
  );
}
